import { render } from "./BusinessDetailPage.vue?vue&type=template&id=0ab34a9c"
import script from "./BusinessDetailPage.vue?vue&type=script&lang=js"
export * from "./BusinessDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__